import React, {FC} from "react";
import {GridColDef} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ProductPO} from "@/model/product";
import isEmpty from "lodash/isEmpty";

export interface ServeTableProps {
    products?: ProductPO[];
}

export const ServeTable: FC<ServeTableProps> = ({products}) => {
    const productColumns: GridColDef<ProductPO>[] = [
        {
            field: "kind",
            headerName: "服务名称",
            headerAlign: "left",
            align: "left",
            flex: 0.6,
            renderCell: ({row}) => {
                if (row.productTypeId == 1 && !isEmpty(row.retard)) {
                    return `${row.kind}-${row.retard}`
                }
                return row.kind
            }
        },
        {
            field: "category",
            headerName: "申请类型",
            flex: 0.4,
        },
        {
            field: "price",
            headerName: "单价",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            valueFormatter: (value) => `￥${value || "-"}`,
        },
        {
            field: "num",
            headerName: "数量",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
        },
        {
            field: "totalPrice",
            headerName: "总价",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            valueFormatter: (value) => `￥${value || "-"}`,
        },
        // {
        //     field: "writer",
        //     headerName: "撰稿人",
        //     headerAlign: "center",
        //     align: "center",
        //     flex: 0.4,
        // }
    ]

    return <ProTable<ProductPO> checkboxSelection={false} showToolbar={false} columnHeaderHeight={40}
                                source={{
                                    dataSource: {
                                        getRows: async () => {
                                            return {rows: products || [], rowCount: products?.length}
                                        }
                                    },
                                    rowCount: products?.length || 0,
                                }}
                                pageSize={5}
                                feet={{hidden: false}}
                                columns={productColumns}/>
}